import _sfc_main from "./MainLayout.vue2.js";
/* empty css                */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const MainLayout = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-3838a846"]]);
export {
  MainLayout as default
};
//# sourceMappingURL=MainLayout.vue.js.map
